import { useCallback, useReducer } from "react";
import SaleModel from "../../../../Models/Sale";
import helper from "../../../../Services/helper";
import globals from "../../../../Services/globals";

const mergeReducer = (state, action) => {
  if (typeof action === "function") {
    return action(state);
  }
  if (action && typeof action === "object" && !Array.isArray(action)) {
    return { ...state, ...action };
  }
  return state;
};

const buildInitialState = (rawSaleTypeId = 0) => {
  const saleTypeId = parseInt(rawSaleTypeId, 10) || 0;
  const defaultQuantity = saleTypeId === 4 ? -1 : 1;
  const logedInUser = globals().getLogedInUser();

  return {
    sale: new SaleModel(),
    saleDetails: [
      {
        no: 1,
        date: new Date(),
        comment: "",
        id: 0,
        itemId: 0,
        itemName: helper().translate("CHOOSE"),
        barcode: helper().translate("CHOOSE_BARCODE"),
        quantity: defaultQuantity,
        price: 0.0,
        avgPrice: "0",
        vat: 0,
        vatForm: 0,
        vatSum: 0,
        projectId: 0,
        addButton: true,
        validate: true,
      },
    ],
    payment: [
      { name: "to be paid", inputValue: 0 },
      { name: "cash", inputValue: 0, objective: "pay" },
      { name: "pos1", bankId: 0, inputValue: 0, objective: "pay", disabled: false },
      { name: "pos2", bankId: 0, inputValue: 0, objective: "pay", disabled: false },
      { name: "pos3", bankId: 0, inputValue: 0, objective: "pay", disabled: false },
      { name: "totalPayment", inputValue: 0 },
      { name: "remainingDebt", inputValue: 0 },
      { name: "returnMoney", inputValue: 0 },
    ],
    paymentBtn: { showPayFrom: false, showPayments: false, pay: false, savePayment: false },
    otherSalesDetails: false,
    paymentSales: [],
    defaultAccount: { defaultCashAccount: 0, defaultBankAccount: 0 },
    banksPos: [],
    warehouse: [],
    branches: [],
    partners: [],
    partnersFull: [],
    salesType: [],
    loader: true,
    settings: [],
    items: [],
    fullItems: [],
    projects: [],
    currentUserCashBoxId: 0,
    units: [],
    vatLevel: [],
    payMethod: [],
    saleVatTypes: [],
    invoiceIdFormat: true,
    allowMultipleDiscount: false,
    validate: false,
    partnerShow: false,
    userSettings: "",
    logedInUser,
    itemSaleOtherDetails: [
      {
        no: 1,
        id: 0,
        paymentsInfo: "",
        quantity: 1,
        priceForUnit: 0.0,
        totalPrice: 0,
        addButton: true,
        validate: true,
        editMode: false,
      },
    ],
    saveSaleOtherDetails: false,
    totalOtherDetails: 0,
    userColumns: [],
    columns: [],
    uncheckedHdrs: [],
    showedHeaders: [],
    showHiddeBox: false,
    isSending: false,
  };
};

export const useSaleState = (saleTypeId = 0) => {
  const [state, dispatch] = useReducer(
    mergeReducer,
    saleTypeId,
    (initialArg) => buildInitialState(initialArg),
  );

  const setState = useCallback(
    (update) => {
      if (typeof update === "function") {
        dispatch((prev) => {
          const result = update(prev);
          if (!result || typeof result !== "object") {
            return prev;
          }
          return { ...prev, ...result };
        });
      } else if (update && typeof update === "object") {
        dispatch(update);
      }
    },
    [dispatch],
  );

  return { state, setState };
};
